<template>
  <div>
    <v-dialog v-model="googleDetailsModal" persistent width="550">
      <v-toolbar class="redColor text-white">
        <v-toolbar-title>{{
          $t("institutions.table.google_details")
        }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          variant="outlined"
          icon
          color="white"
          @click="closeGoogleDetailsModal"
        >
          <v-icon small> mdi-close </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card class="pa-3">
        <v-progress-linear
          v-if="loading"
          color="#D32F2F"
          indeterminate
          rounded
          height="6"
        />
        <div class="pb-3">
          <v-alert
            :model-value="true"
            type="error"
            border="bottom"
            variant="tonal"
          >
            {{ $t("institutions.form.google_condition") }}
          </v-alert>
        </div>
        <div class="pb-3">
          <v-text-field
            v-model="item.googleId"
            :label="$t('institutions.form.googleId')"
            color="red-darken-1"
            prepend-icon="mdi-security"
          />
        </div>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red-darken-1"
            variant="outlined"
            @click="closeGoogleDetailsModal"
          >
            {{ $t("institutions.form.close") }}
          </v-btn>
          <v-btn
            color="green"
            variant="outlined"
            :disabled="checkGoogleDetails"
            @click="saveGoogleDetails"
          >
            {{ $t("institutions.form.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="googleErrorDialog" persistent width="500">
      <v-card class="pa-3">
        <v-alert
          :model-value="true"
          type="error"
          border="bottom"
          variant="tonal"
        >
          {{ googleResponse }}
        </v-alert>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn small @click="googleErrorDialog = false"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="alert" max-width="500">
      <v-card class="pa-3">
        <v-alert
          v-model="alert"
          type="success"
          border="bottom"
          variant="tonal"
          :model-value="true"
        >
          {{ $t("institutions.form.verification_success") }}
        </v-alert>
      </v-card>
    </v-dialog>
    <v-dialog v-model="success" max-width="300">
      <v-card class="pa-3">
        <v-alert
          v-model="success"
          type="success"
          border="bottom"
          variant="tonal"
          :model-value="true"
        >
          {{ $t("institutions.form.success") }}
        </v-alert>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  data: () => ({
    institution_id: null,
    googleDetailsModal: false,
    item: {
      googleId: "",
    },
    googleResponse: null,
    googleErrorDialog: false,
    loading: false,
    alert: false,
    inst: null,
    loadingSave: false,
    institutionDetails: null,
    // baseUrl: 'http://localhost:3000',
    baseUrl: "https://api.lekotech.com",
    rules: {
      required: [(v) => !!v || "Please fill this field"],
    },
    valid: false,
    success: false,
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
    checkGoogleDetails() {
      return !this.item.googleId;
    },
  },
  watch: {
    valid(value) {
      this.$emit("valid", value);
    },
  },
  methods: {
    openGoogleDetailsModal(institution) {
      this.institution_id = institution._id;
      this.inst = institution;
      this.item.googleId = institution.googleMerchantId || "";
      this.googleDetailsModal = true;
    },
    saveGoogleDetails() {
      this.loading = true;
      axios
        .put(
          `${this.baseUrl}/institution/edit-google-merchant-details/${this.institution_id}`,
          { googleMerchantId: this.item.googleId },
          {
            headers: { authorization: localStorage.token },
          },
        )
        .then((response) => {
          if (response && response.data && response.data.errorMsg) {
            this.googleResponse = response.data.errorMsg;
            this.googleErrorDialog = true;
          } else {
            this.alert = true;
            this.googleDetailsModal = false;
            this.item.googleId =
              response.data && response.data.googleMerchantId
                ? response.data.googleMerchantId
                : "";
            setTimeout(() => {
              this.alert = false;
            }, 3000);
            this.$emit("fetchInstitutionDetails");
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeGoogleDetailsModal() {
      this.googleDetailsModal = false;
      this.$emit("fetchInstitutionDetails");
    },
  },
};
</script>
